import { Activity, LayoutDashboard, Repeat, Settings } from "lucide-react";
import type { LucideIcon } from "lucide-react";

export type NavItem = {
  title: string;
  href: string;
  icon: LucideIcon;
  /**
   * Legacy numeric id kept in sync with `activeStatus` in user-context, which
   * other screens still read. Active state itself is derived from the URL.
   */
  status: number;
};

/**
 * Single source of truth for the primary navigation. Rendered once and shared
 * by the desktop rail and the mobile sheet.
 *
 * Wallet (status 2) and Sales (status 5) are intentionally absent — they were
 * commented out of the old sidebar. Re-add them here when those pages ship.
 */
export const navItems: NavItem[] = [
  { title: "Dashboard", href: "/dashboard", icon: LayoutDashboard, status: 1 },
  { title: "Payments", href: "/payment", icon: Repeat, status: 3 },
  { title: "Activity", href: "/activity", icon: Activity, status: 4 },
  { title: "Settings", href: "/settings", icon: Settings, status: 6 },
];

export const SUPPORT_URL = "https://wa.link/1zlp0c";
